import gql from "graphql-tag";

export default gql`
  mutation authenticateSSOUser(
    $email: String
    $password: String
    $prefferedLanguage: String
    $redirectLocation: String
  ) {
    authenticateSSOUser(
      email: $email
      password: $password
      prefferedLanguage: $prefferedLanguage
      redirectLocation: $redirectLocation
    ) {
      token
      refreshToken
      redirectLocation
      SSOAccountRole
      email
      primaryAccountId
    }
  }
`;
